import React, { useMemo } from 'react';
import { Modal, Button, message } from 'antd-v5';
import { connect } from 'react-redux';
import MassMessageForm from '../../../../shared/MassMessageForm';
import { useCreateMassMessage, useUpdateMassMessage } from '../../../../../hooks/query/useMassMessages';
import { DEFAULT_TEMPLATE_BUTTONS } from '../../../../shared/MassMessageForm/constants';
import { queryMaker } from '../../../../../core/apiRequests';
import './MassMessageModal.scss';

const MassMessageModal = ({ open, onClose, eventId, audienceId, audienceCount, editingMessage, auth }) => {
  const createMutation = useCreateMassMessage();
  const updateMutation = useUpdateMassMessage();

  const templateButtons = useMemo(() => {
    const eventBookingUrl = `${process.env.REACT_APP_OPT_IN_FORM_URL}${queryMaker({
      merchantUuid: auth?.uuid,
      type: 'event',
      eventId,
    })}`;
    return [
      ...DEFAULT_TEMPLATE_BUTTONS,
      { value: eventBookingUrl, label: 'Event Link', plainText: true },
    ];
  }, [auth?.uuid, eventId]);

  const isEditMode = !!editingMessage;
  const isSaving = createMutation.isLoading || updateMutation.isLoading;

  const handleFormSubmit = async formData => {
    const payload = {
      ...formData,
      eventId,
      audience: { id: audienceId },
    };

    try {
      if (isEditMode) {
        await updateMutation.mutateAsync({ massMessageId: editingMessage.id, data: payload });
        message.success('Message updated successfully');
      } else {
        await createMutation.mutateAsync(payload);
        message.success('Message scheduled successfully');
      }
      onClose();
    } catch (error) {
      console.error('Error saving mass message:', error);
      message.error('Failed to save message. Please try again.');
    }
  };

  return (
    <Modal open={open} onCancel={onClose} width={900} footer={null} destroyOnClose className="mass-message-modal">
      <MassMessageForm
        audienceCount={audienceCount}
        editingMessage={open ? editingMessage : undefined}
        onSubmit={handleFormSubmit}
        isSaving={isSaving}
        showCostAlways
        templateButtons={templateButtons}
        renderActions={(handleSubmit, saving) => (
          <div className="mass-message-modal__header">
            <h2 className="mass-message-modal__title">Scheduled message</h2>
            <div className="mass-message-modal__header-actions">
              <Button type="primary" onClick={handleSubmit} loading={saving}>
                Schedule to Send
              </Button>
            </div>
          </div>
        )}
      />
    </Modal>
  );
};

const mapStateToProps = state => ({
  auth: state.auth,
});

export default connect(mapStateToProps)(MassMessageModal);
